module.exports = __webpack_public_path__ + "static/media/top.14d2cfd2.svg";